<script>
  import Documents from '@components/messenger/Documents.svelte';
  import ConversationEmptyState from './sharing/ConversationEmptyState.svelte';

  export let conversationId = null;
</script>

{#if conversationId}
  <Documents {conversationId} />
{:else}
  <ConversationEmptyState
    variant="sidebar"
    title="Chi tiết cuộc hội thoại"
    description="Chọn một cuộc trò chuyện để xem ảnh, video, tệp và liên kết đã được chia sẻ trong đoạn chat đó." />
{/if}
